import React from 'react';
import { ODIcon, ODIcons } from '../../icons';
import { pickNumberEnumValues } from '../../utils';
import { ODFullLayout } from '../layout';
import { ODSpace } from '../misc';
export var ODIconsGallery = function () {
    return (React.createElement(ODFullLayout, null,
        React.createElement("div", { className: "w-full p-4 flex flex-col" },
            React.createElement("h3", null, "Add more icons"),
            React.createElement("hr", null),
            React.createElement("a", { href: "https://icons.coreui.io/icons/" }, "Core UI Icons"),
            React.createElement("a", { href: "https://material-ui.com/components/material-icons/" }, "Material Icons"),
            React.createElement("a", { href: "https://fontawesome.com/icons?d=gallery" }, "Font Awesome Icons"),
            React.createElement("a", { href: "https://simplelineicons.github.io/" }, "Simple Line Icons")),
        React.createElement("div", { className: "w-full p-4 flex flex-col" },
            React.createElement("h2", null, "Defined ODcode Icons"),
            React.createElement("div", { className: "w-full grid grid-cols-6 gap-x-4 gap-y-4 p-4" }, pickNumberEnumValues(ODIcons).map(function (v) { return (React.createElement("div", { key: v, className: "flex flex-col justify-center items-center w-full h-full text-gray-900" },
                React.createElement(ODIcon, { icon: v, className: "w-6 h-6" }),
                React.createElement(ODSpace, { minSize: 10, v: true }),
                React.createElement("span", { className: "text-gray-800", style: { fontSize: 14 } }, ODIcons[v]))); })))));
};
//# sourceMappingURL=ODIconsGallery.js.map